import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theming/Theming';
import { convertPropsToObject } from '../ContentRender';
import ImageComponent from './ImageComponent';
import { RowHeader } from './RowHeader';
import { ScrollBox } from '../../ui/ScrollBox';
import { contentTextElements } from '../ContentText';

const ImageRowWrapper = styled.div`
  .image-row-children {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: 100%;
    }
  }
  [data-columns='1'] > div {
    width: 100%;
    ${theme.below.sm} {
      [data-flight-image-container] {
        padding-bottom: 100% !important;
      }
    }
  }
  [data-columns='2'] > div {
    ${theme.above.md} {
      width: 50%;
    }
  }
  [data-columns='3']:not(.mosaic) > div {
    ${theme.above.md} {
      width: 33.33333%;
    }
  }
  [data-columns='4'] > div {
    ${theme.above.sm} {
      width: 50%;
    }
    ${theme.above.lg} {
      width: 25%;
    }
  }

  //MOSAIC LOOK
  [data-columns='3'].mosaic:not(.right) {
    > div:nth-of-type(1) {
      width: 100%;
    }
    > div:nth-of-type(2),
    > div:nth-of-type(3) {
      width: 50%;
    }
    ${theme.above.lg} {
      > div:nth-of-type(1) {
        width: 50%;
      }
      > div:nth-of-type(2),
      > div:nth-of-type(3) {
        width: 25%;
      }
      //IMAGE SIZES
      > div:nth-of-type(1) {
        [data-flight-image-container] {
          padding-bottom: 50% !important;
        }
      }
      > div:nth-of-type(2),
      > div:nth-of-type(3) {
        [data-flight-image-container] {
          padding-bottom: 100% !important;
        }
      }
    }
  }

  //MOSAIC RIGHT LOOK
  [data-columns='3'].mosaic.right {
    > div:nth-of-type(1),
    > div:nth-of-type(2) {
      width: 50%;
    }
    > div:nth-of-type(3) {
      width: 100%;
    }
    ${theme.above.lg} {
      > div:nth-of-type(1),
      > div:nth-of-type(2) {
        width: 25%;
      }
      > div:nth-of-type(3) {
        width: 50%;
      }
      //IMAGE SIZES
      > div:nth-of-type(1),
      > div:nth-of-type(2) {
        [data-flight-image-container] {
          padding-bottom: 100% !important;
        }
      }
      > div:nth-of-type(3) {
        [data-flight-image-container] {
          padding-bottom: 50% !important;
        }
      }
    }
  }

  //BACKGROUND
  &.primary,
  &.secondary {
    background: ${theme.startPage.row.background.primary};
    ${contentTextElements} {
      color: ${theme.startPage.row.color.primary};
    }
    padding: 2rem 5px 2rem 5px;
    ${theme.above.lg} {
      padding: 3rem 5px 2rem 5px;
    }
    .row-header {
      margin: 0 0 1rem;
    }
    .image-row-inner {
      display: flex;
      flex-direction: column;
    }
  }
  &.secondary {
    background: ${theme.startPage.row.background.secondary};
    ${contentTextElements} {
      color: ${theme.startPage.row.color.secondary};
    }
  }

  //MARGINS BETWEEN IMAGES
  &.margins {
    .row-header {
      margin-bottom: 1rem;
    }
    .image-row-inner {
      max-width: ${theme.general.maxWidth};
      margin: 0 auto;
      padding: 0 ${theme.general.pagePadding.sm};
      ${theme.below.md} {
        padding: 0;
      }
      .image-row-children {
        padding-top: 2%;
        > div {
          margin-bottom: 2%;
        }
        &[data-columns='2'] > div {
          ${theme.above.md} {
            width: 49%;
          }
        }
        &[data-columns='3']:not(.mosaic) > div {
          ${theme.above.md} {
            width: 32%;
          }
        }
        &[data-columns='4'] > div {
          ${theme.above.sm} {
            width: 49%;
          }
          ${theme.above.lg} {
            width: 24%;
          }
        }
        //MOSAIC LOOK
        &[data-columns='3'].mosaic:not(.right) {
          padding-top: 0;
          > div {
            margin-bottom: 1.8%;
          }
          > div:nth-of-type(1) {
            width: 100%;
          }
          > div:nth-of-type(2),
          > div:nth-of-type(3) {
            width: 49%;
          }
          ${theme.above.lg} {
            > div:nth-of-type(1) {
              width: 49%;
            }
            > div:nth-of-type(2),
            > div:nth-of-type(3) {
              width: 24%;
            }
            //IMAGE SIZES
            > div:nth-of-type(1) {
              [data-flight-image-container] {
                padding-bottom: 50% !important;
              }
            }
            > div:nth-of-type(2),
            > div:nth-of-type(3) {
              [data-flight-image-container] {
                padding-bottom: 102% !important;
              }
            }
          }
        }
        //MOSAIC RIGHT LOOK
        &[data-columns='3'].mosaic.right {
          padding-top: 0;
          > div {
            margin-bottom: 1.8%;
          }
          > div:nth-of-type(1),
          > div:nth-of-type(2) {
            width: 49%;
          }
          > div:nth-of-type(3) {
            width: 100%;
          }
          ${theme.above.lg} {
            > div:nth-of-type(1),
            > div:nth-of-type(2) {
              width: 23.5%;
            }
            > div:nth-of-type(3) {
              width: 49.5%;
            }
            //IMAGE SIZES
            > div:nth-of-type(1),
            > div:nth-of-type(2) {
              [data-flight-image-container] {
                padding-bottom: 105% !important;
              }
            }
            > div:nth-of-type(3) {
              [data-flight-image-container] {
                padding-bottom: 50% !important;
              }
            }
          }
        }
      }
    }
  }

  //SLIDER WIDTH
  .slider-items {
    .image-component-wrapper {
      margin-right: 2%;
      ${theme.only.sm} {
        width: 55%;
      }
      ${theme.only.md} {
        width: 37%;
      }
      ${theme.only.lg} {
        width: 27%;
      }
      ${theme.above.xl} {
        width: 21%;
      }
    }
  }
`;

const ImageRowChildren = ({ children, aspect, look }) => (
  <>
    {children.map((child, index) => (
      <ImageComponent
        data={child}
        columns={children.length}
        aspect={aspect}
        key={index}
        look={look}
      />
    ))}
  </>
);

const ImageRow = ({ data, index }) => {
  const props = convertPropsToObject(data);
  const aspect = props.imageAspectRatio.value;
  const margins = props.imageMargins.value;
  const background = props.background.value;
  const columns = data.children.length;
  const header = props.header.value;
  const look = props.look.value;

  //SPECIAL IMAGE SIZES FOR MOSAIC LOOK
  const sizes =
    look.search('mosaic') !== -1 && index === 1 ? [1, 1, 1, 1 / 2] : null;

  const mosaicRight = look === 'mosaic-right';

  let cssStyles = margins === 'yes' ? 'margins' : '';
  cssStyles += ' ' + background;
  cssStyles += header ? ' has-header' : '';

  if (data && data.children)
    return (
      <ImageRowWrapper
        data-columns={columns}
        data-index={index}
        className={`image-row ${cssStyles}`}
      >
        <div className="image-row-inner">
          <RowHeader props={props} />
          {columns > 4 && look === 'standard' ? (
            <ScrollBox>
              <ImageRowChildren
                children={data.children}
                aspect={aspect}
                sizes={sizes}
              />
            </ScrollBox>
          ) : (
            <div
              className={`image-row-children ${
                mosaicRight ? 'mosaic right' : look
              }`}
              data-columns={columns}
            >
              <ImageRowChildren
                children={data.children}
                aspect={aspect}
                sizes={sizes}
              />
            </div>
          )}
        </div>
      </ImageRowWrapper>
    );
  else return null;
};

export default ImageRow;
